export default {
    info: {
        nome: 'Pedrinho',
        jogador: 'El Brabo',
        idade: '20',
        sexo: 'Masculino',
        image: 'https://media.discordapp.net/attachments/381303520336543745/837608287821365248/tenor_6.gif',
    },
    stats: {
        vida: 20,
        vida_max: 20,
        sanidade: 70,
        sanidade_max: 70,
        exposicao_paranormal: 50,
        exposicao_paranormal_max: 100
    },
    attributes: {
        aparencia: 10,
        constituicao: 10,
        destreza: 10,
        forca: 10,
        inteligencia: 10,
        poder: 10,
        sorte: 10,
        movimento: 10,
    },
    other: {
        carreira: "Caçador de M.",
        pessoas_importantes: "Aluno, Emma",
        percences_queridos: "Isqueiro, Foto, Arco",
        locais_importantes: "Nenhum"
    },
    skills: {
        "Antropologia": 20,
        "Armas Brancas": 15,
        "Armas de Fogo": 17,
        "Arqueologia": 19,
        "Arremessar": 5,
        "Arrombamento": 2,
        "Arte": 5,
        "Astronomia": 8,
        "Atletismo": 12,
        "Avaliar Honestidade": 10,
        "Barganhar": 10,
        "Biologia": 10,
        "Charme": 10,
        "Chaveiro": 10,
        "Ciência Forense": 10,
        "Consertos Elétricos": 10,
        "Consertos Mecânicos": 10,
        "Computação": 10,
        "Criptografia": 10,
        "Direito": 10,
        "Dirigir Automóveis": 10,
        "Disfarce": 10,
        "Eletrônica": 10,
        "Encontrar": 10,
        "Escalar": 10,
        "Escutar": 10,
        "Esquivar": 10,
        "Etiqueta": 10,
        "Farmácia": 10,
        "Flertar": 10,
        "Fotografia": 10,
        "Furtividade": 10,
        "História": 10,
        "Interrogação": 10,
        "Intimidação": 10,
        "Lábia": 10,
        "Língua Nativa": 10,
        "Língua Estrangeira": 10,
        "Lutar": 10,
        "Maldições": 10,
        "Manha": 10,
        "Medicina": 10,
        "Natação": 10,
        "Ofício": 10,
        "Persuadir": 10,
        "Pesquisar Biblioteca": 10,
        "Pilotar": 10,
        "Primeiros Socorros": 10,
        "Psicanálise": 10,
        "Pular": 10,
        "Química": 10,
        "Rastrear": 10,
        "Sobrevivência": 10,
        "Teologia": 10,
    },
    inventory: {
        backpackWeight: 30,
        money: 50,
        items: [
            {
                name: "Faca",
                description: "Faca poderosa - Dano d10",
                weight: 1.0,
                quantity: 1
            },
            {
                name: "Pistola",
                description: "Pistola foda - Dano d12",
                weight: 2.0,
                quantity: 1
            }
        ]
    }
}
